// extracted by mini-css-extract-plugin
module.exports = {"content":"Company_content__3-vHL","image":"Company_image__nchx2","header":"Company_header__27lN0"};